export const QUERY_PRESETS = [
  {
    label: 'All logs (newest first)',
    query: 'sort @timestamp desc',
  },
  {
    label: 'Errors only',
    query: 'filter level = "error" | sort @timestamp desc',
  },
  {
    label: 'Errors & warnings',
    query: 'filter level in ["error", "warn"] | sort @timestamp desc',
  },
  {
    label: 'Error count by level',
    query: 'stats count(*) by level',
  },
  {
    label: 'Has exception info',
    query: 'filter ispresent(exc_info) | sort @timestamp desc',
  },
];
